module.exports = __webpack_public_path__ + "img/ai-streamer-avatar.13fc2bf3.png";